import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import S from 'app/features/billing/components/Plans/Plans.styled';
import PlanItem from 'app/features/billing/components/Plans/PlanItem';
import { selectedProductPlansToShowOnBilling } from 'app/features/products/selectors';

const UI = ({ plans }) => (
  <S.Plans>
    <S.PlanItemsList>
      {plans.map(sku => (
        <PlanItem key={sku} sku={sku} />
      ))}
    </S.PlanItemsList>
  </S.Plans>
);

UI.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.string).isRequired,
};

UI.displayName = 'Plans';

const Plans = connect({ plans: selectedProductPlansToShowOnBilling })(UI);

export { UI };

export default Plans;
